import OrganizationManage from './OrganizationManage.vue'
export default OrganizationManage
